import { Grid2 } from "@mui/material";
import CompanySelect from "components/global/CompanySelect";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import ContactSelectDropdown from "../global/ContactSelectDropdown";
import { actions } from "./logic/contactActions";

const ContactSearch = (props) => {
    const {
        selectCompany,
        selectContact,
        advTypes,
        contactRoles,
        selectedContact,
        selectedCompany,
        selectCompanyFromContact,
    } = props;

    function __getContactAdvTypes(contact) {
        return contact.advertisementTypesIds.map((advId) => advTypes.find((adv) => adv.id === advId));
    }

    function __getContactContactRoles(contact) {
        return contact.contactRolesIds.map((contactId) => contactRoles.find((contact) => contact.id === contactId));
    }

    function __getContactWithAllInfo(contact) {
        return { ...contact, advTypes: __getContactAdvTypes(contact), contactRoles: __getContactContactRoles(contact) };
    }

    function onChangeCompany(company) {
        selectCompany(company);
    }

    function onChangeContact(contact) {
        if (contact) {
            selectContact(__getContactWithAllInfo(contact));
        }
        if (contact && !selectedCompany.id) {
            selectCompanyFromContact(contact.companyId);
        }
    }

    const isCompanySelected = selectedCompany && selectedCompany.id;
    const isContactSelected = selectedContact && selectedContact.id;
    return (
        <Grid2 container spacing={4} style={{ marginBottom: 30 }}>
            <Grid2 size={12}>
                <CompanySelect onChange={onChangeCompany} defaultValue={isCompanySelected ? selectedCompany : null} />
            </Grid2>
            <Grid2 size={12}>
                <ContactSelectDropdown
                    defaultValue={isContactSelected ? selectedContact : null}
                    onChange={onChangeContact}
                    onSelectCompany={onChangeCompany}
                    company={isCompanySelected ? selectedCompany : null}
                />
            </Grid2>
        </Grid2>
    );
};

ContactSearch.propTypes = {
    advTypes: PropTypes.array.isRequired,
    contactRoles: PropTypes.array.isRequired,
    contacts: PropTypes.array.isRequired,
    selectedContact: PropTypes.object,
    selectedCompany: PropTypes.object,
    selectCompany: PropTypes.func.isRequired,
    selectContact: PropTypes.func.isRequired,
    selectCompanyFromContact: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    advTypes: state.globalApp.advertisementTypes,
    contactRoles: state.globalApp.contactRoles,
    contacts: state.contacts.selectedCompany.contacts,
    selectedContact: state.contacts.selectedContact,
    selectedCompany: state.contacts.selectedCompany,
});

const mapDispatchToProps = (dispatch) => ({
    selectCompany: (company) => dispatch(actions.SELECT_COMPANY.call(company)),
    selectContact: (contact) => dispatch(actions.SELECT_CONTACT.call(contact)),
    selectCompanyFromContact: (id) => dispatch(actions.GET_COMPANY.send(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactSearch);
